module.exports = __webpack_public_path__ + "img/VIREN DARJI.4e848b5b.jpg";